import { render } from "./InvoiceForm.vue?vue&type=template&id=ff28cfd4&scoped=true"
import script from "./InvoiceForm.vue?vue&type=script&lang=js"
export * from "./InvoiceForm.vue?vue&type=script&lang=js"

import "./InvoiceForm.vue?vue&type=style&index=0&id=ff28cfd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff28cfd4"]])

export default __exports__